<template>
    <div class="concepto-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="400">
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-card-text>
                            <v-form ref="conceptoForm" v-model="validConcepto">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex xs12 sm12>
                                            <v-text-field
                                                v-model="conceptoItem.nombre"
                                                label="Nombre"
                                                :rules="nombreFieldRules"
                                                :error-messages="nombreFieldErrors"
                                                :counter="255"
                                                @keydown="nombreFieldErrors = []"
                                                @keypress.enter.prevent="saveForm()"
                                            >
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm12>
                                            <v-select
                                                v-model="conceptoItem.departamento_id"
                                                :items="DEPARTAMENTOS"
                                                label="Departamento*"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="departamento_idRules"
                                                :error-messages="departamento_idErrors"
                                                @blur="departamento_idErrors = []"
                                            >
                                            </v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
    props: {
        formTitle: { type: String, default: null },
        initialItem: { type: Object, default: null }
    },
    data() {
        return {
            loading: false,
            validConcepto: false,
            conceptoItem: {
                nombre: "",
                departamento_id: null
            },
            nombreFieldRules: [
                v => !!v || "Debe proporcionar un nombre",
                v => v.length <= 255 || "El nombre solo puede contener 255 caracteres"
            ],
            nombreFieldErrors: [],
            departamento_idRules: [v => !!v || "Debe proporcionar el departamento."],
            departamento_idErrors: []
        }
    },
    computed: {
        ...mapGetters(["DEPARTAMENTOS"]),

        isNewRecord() {
            return this.initialItem === null
        },

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        disableSaveButton() {
            return this.loading || !this.validConcepto
        }
    },

    methods: {
        saveForm() {
            this.loading = true
            this.$refs.conceptoForm.validate()
            if (this.validConcepto) {
                let concepto = {
                    nombre: this.conceptoItem.nombre,
                    departamento_id: this.conceptoItem.departamento_id
                }

                if (!this.isNewRecord) {
                    concepto.id = this.conceptoItem.id
                }

                this.$store.dispatch(this.isNewRecord ? "ADD_CONCEPTO" : "UPDATE_CONCEPTO", concepto).then(result => {
                    if (!result) {
                        //no hay coneccion con el servidor
                        this.loading = false
                    }
                    if (result === null || result.status === 404 || result.status === 500) {
                        //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe
                        this.$emit("formCanceled")
                    } else {
                        // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                        let { data, status } = result
                        if (status === 422) {
                            data.forEach(error => {
                                if (error.field === "nombre") {
                                    this.nombreFieldErrors.push(error.message)
                                } else if (error.field === "departamento_id") {
                                    this.departamentoFieldErrors.push(error.message)
                                }
                            })
                        }
                    }
                    this.loading = false
                })
            } else {
                this.loading = false
            }
        },
        cancelForm() {
            this.$emit("formCanceled")
        }
    },

    created() {
        this.$store.dispatch("LOAD_ALL_DEPARTAMENTOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        if (this.initialItem !== null) {
            // Cargando información del elemento a actualizar
            this.conceptoItem.id = this.initialItem.id
            this.conceptoItem.nombre = this.initialItem.nombre
            this.conceptoItem.departamento_id = this.initialItem.departamento_id
        }
    }
}
</script>

<style scoped></style>
